<template>
  <b-button
    id="new-campaign-event-button"
    variant="info"
    block
    pill
    @click="() => open()"
  >
    New Campaign Event
  </b-button>
</template>

<script>
import { EventBus } from "@/events/eventBus";
import GroupNotificationForm from "@/components/campaigns/GroupNotificationForm";

export default {
  name: "NewNotificationButton",
  methods: {
    open() {
      const $ = window.$;
      $("#id-modal-container").modal({
        backdrop: "static"
      });
      EventBus.$emit("open", {
        component: GroupNotificationForm,
        title: "New Campaign Event",
        actionButton: "Create Campaign Event",
        closeOnClick: true,
      });
    }
  }
};
</script>
